//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const DatasourceUniqueColumnSetting: FeatureFlag = {"Id":"DatasourceUniqueColumnSetting","Label":"[10.24]Enable datasource unique column setting","Impact":"When enabled, datasource column editors expose the unique-values setting and saves persist column uniqueness. When disabled, the editor hides that setting and saves preserve the old non-unique behavior.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
